module.exports = __webpack_public_path__ + "img/img_2.a94e43e3.jpg";